import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AdminManagerService } from "../../admin/services/admin-manager.service";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { getParameterByName } from "@devwareapps/devware-cap";
import { tap } from "rxjs/operators";
import { IntegrationHeaders } from "../models/integration-headers.enum";
import IntegrationUtilService from "../services/integration-util.service";

@Injectable()
export class IntegrationDataHttpInterceptor implements HttpInterceptor {

    
    constructor(private integrationUtilService: IntegrationUtilService) {

    }

    AVIATOR_USER_INTEGRATION_RESPONSE = "AVIATOR_USER_INTEGRATION_RESPONSE";
    AVIATOR_SCHOOL_INTEGRATION_RESPONSE = "AVIATOR_SCHOOL_INTEGRATION_RESPONSE";

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers: { [prop:string]: string } = {};

        // Check if there is a type and token so we can pass it to the client
        const type = this.integrationUtilService.getIntegrationTokenTypeParam();
        const token = this.integrationUtilService.getIntegrationTokenParam();

        if (type && token) {
            headers[IntegrationHeaders.AVIATOR_INTEGRATION_TYPE] = type;
            headers[IntegrationHeaders.AVIATOR_INTEGRATION_TOKEN] = token;
        }

        request = request.clone({
            headers: request.headers,
            setHeaders : headers
        })

        return next.handle(request) 
        .pipe(tap(event => {
            try {
                if (event instanceof HttpResponse) {
                    const eventResponse = event as HttpResponse<any>;
                    const userIntegrationResponse = eventResponse.headers.get(this.AVIATOR_USER_INTEGRATION_RESPONSE);
                    const schoolIntegrationResponse = eventResponse.headers.get(this.AVIATOR_SCHOOL_INTEGRATION_RESPONSE);
    
                    setTimeout(() => {
                        if (userIntegrationResponse) {
                            this.integrationUtilService.handleUserIntegrationResponse(userIntegrationResponse);
                        }
                        if (schoolIntegrationResponse) {
                            this.integrationUtilService.handleSchoolIntegrationResponse(schoolIntegrationResponse);
                        }
                    }, 400);
                }
            } catch(e) {
                console.warn("Error in IntegrationDataHttpInterceptor", e);
            }
        }));
    }
}